<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 2C3.94772 2 3.5 2.44772 3.5 3V13C3.5 13.5523 3.94772 14 4.5 14H5.5C6.05228 14 6.5 13.5523 6.5 13V3C6.5 2.44772 6.05228 2 5.5 2H4.5Z" fill="black"/>
<path d="M10.5 2C9.94772 2 9.5 2.44772 9.5 3V13C9.5 13.5523 9.94771 14 10.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V3C12.5 2.44772 12.0523 2 11.5 2H10.5Z" fill="black"/>
</svg>
